// extracted by mini-css-extract-plugin
module.exports = {"dashboard":"Dashboard_dashboard__sNKcI","name":"Dashboard_name__hc_7b"};